module.exports = "/_next/static/images/toybox-closed-d24a3796676fff7c5674ceda898c9c83.svg";